import { styled } from '@mui/material';

export const EditorRoot = styled('main')(({ theme }) => ({
  height: '100dvh',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.background.default,
  overflow: 'hidden',
}));

export const EditorHeader = styled('header')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 2),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const EditorFrame = styled('iframe')({
  display: 'block',
  width: '100%',
  flex: 1,
  minHeight: 0,
  border: 0,
});
